/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-19 17:35:54
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/outFishProfitOrg/searchOutFishProfitOrgList`
  return http.post(url, data)
}

// 养成--获取所有机构--成本概览
export function getAllJiGou(rootId){
  const url = `/desktopReport/queryIndexBaseFish/${rootId}`
  return http.get(url)
}

// 养成--获取所有造次--成本概览
export function getAllPiCi(rootId){
  const url = `/desktopReport/queryPerioysFish/${rootId}`
  return http.get(url)
}
// 养成--获取所有品类--成本概览
export function getAllPinLei(rootId){
  const url = `/desktopReport/queryIndexTypeFish/${rootId}`
  return http.get(url)
}
// 养成--获取所有品种--成本概览
export function getAllPinZhong(rootId){
  const url = `/desktopReport/queryIndexBreedFish/${rootId}`
  return http.get(url)
}


